module.exports = __webpack_public_path__ + "static/media/anna.7435323d.jpg";